import { render, staticRenderFns } from "./BuildingCounter.vue?vue&type=template&id=630d719c&scoped=true&"
import script from "./BuildingCounter.vue?vue&type=script&lang=js&"
export * from "./BuildingCounter.vue?vue&type=script&lang=js&"
import style0 from "./BuildingCounter.vue?vue&type=style&index=0&id=630d719c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d719c",
  null
  
)

export default component.exports